import { render } from "./App.vue?vue&type=template&id=2eb660b0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2eb660b0&lang=css"

import exportComponent from "C:\\IdeaWork\\Dweb2024\\store-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__